var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAnaylticsLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 13,
    viewBox: "0 0 24 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9e9e9e",
    d: "M22.818 8a2.173 2.173 0 0 0-2.105 2.719l-3.873 3.857a2.237 2.237 0 0 0-1.135 0l-2.782-2.762a2.177 2.177 0 1 0-4.211 0l-4.974 4.928a2.163 2.163 0 1 0 1.549 1.538l4.964-4.94a2.237 2.237 0 0 0 1.135 0l2.781 2.76a2.177 2.177 0 1 0 4.211 0l3.884-3.846A2.167 2.167 0 1 0 22.818 8z",
    transform: "translate(-1 -8)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnaylticsLine);
export default __webpack_public_path__ + "static/media/icon-anayltics-line.9385bab5.svg";
export { ForwardRef as ReactComponent };